import { NgModule } from '@angular/core';
import { CommonFiledbyComponent } from './common-filedby.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { BusinessContactInfoComponent } from './component/business-contact-info/business-contact-info.component';
import { NestedFiledbySectionComponent } from './component/nested-filedby-section/nested-filedby-section.component';

@NgModule({
  declarations: [CommonFiledbyComponent,BusinessContactInfoComponent,NestedFiledbySectionComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  exports: [CommonFiledbyComponent,BusinessContactInfoComponent,NestedFiledbySectionComponent]
})
export class CommonFiledbyModule { }
